import sideBar from './sideBar';

export default { sideBar };
